import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, token, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <h3>Verifying access...</h3>
      </div>
    );
  }

  if (!token) {
    // Redirect to login if not authenticated
    const loginPath = location.pathname.includes("/gatep") 
      ? "/db-shiksha/gatep/login" 
      : "/db-shiksha/kaas/login";
    return (
      <Navigate to={loginPath} state={{ from: location }} replace />
    );
  }

  // Enforce area-based role checks
  const isKaasAdminPath = location.pathname.startsWith("/db-shiksha/kaas/admin");
  const isKaasStudentPath = location.pathname.startsWith("/db-shiksha/kaas/student");
  const isGatepPath = location.pathname.includes("/gatep");

  if (isKaasAdminPath && user?.role !== "Admin" && user?.role !== "Instructor") {
    return <Navigate to="/db-shiksha/kaas/student/home" replace />;
  }
  if (
    isKaasStudentPath &&
    (user?.role === "Admin" || user?.role === "Instructor")
  ) {
    return <Navigate to="/db-shiksha/kaas/admin/dashboard" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    let redirectPath = "/db-shiksha/kaas/student/home"; // Default

    if (isGatepPath) {
      if (user?.role === "talent") redirectPath = "/db-shiksha/gatep/talent";
      else if (user?.role === "employer") redirectPath = "/db-shiksha/gatep/employer";
      else if (user?.role === "admin") redirectPath = "/db-shiksha/gatep/admin";
      else redirectPath = "/db-shiksha/gatep/login";
    } else {
      redirectPath = (user?.role === "Admin" || user?.role === "Instructor")
        ? "/db-shiksha/kaas/admin/dashboard"
        : "/db-shiksha/kaas/student/home";
    }
    
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

export default ProtectedRoute;
